import * as React from 'react'
import cx from 'classnames'

import styles from './Section.sass'
import Spinner from 'components/Spinner'

const { isSupported, copy } = require('clipbrd')

interface SectionProps {
  title: string
  bordered?: boolean
  children: React.ReactNode
  loading?: boolean
}

const Section = function ({
  title,
  children,
  bordered = false,
  loading,
}: SectionProps) {
  return (
    <div className={styles.root}>
      <div className={cx(styles.section, bordered && styles.bordered)}>
        <div className={styles.sectionHeader}>{title}</div>

        {loading ? (
          <div className={styles.loading}>
            <Spinner size={24} />
          </div>
        ) : (
          <div className={styles.content}>{children}</div>
        )}
      </div>
    </div>
  )
}

interface SectionItemProps {
  label: string
  value?: string
  maskedValue?: string
  isSensitive?: boolean
  copyable?: boolean
}

const SectionItem = function ({
  label,
  value,
  maskedValue,
  isSensitive,
  copyable = true,
}: SectionItemProps) {
  const hasMaskedValue = maskedValue !== undefined
  const [isVisible, setIsVisible] = React.useState(false)

  const copyTextToClipboard = (text: string) => {
    if (isSupported()) {
      copy(text)
    }
  }

  return (
    <div className={styles.contentItem}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>
        <div
          className={styles.masked}
          {...((isSensitive || hasMaskedValue) && { 'data-private': 'true' })}
        >
          {hasMaskedValue && !isVisible ? maskedValue : value}
        </div>
        <div>
          {hasMaskedValue && (
            <span
              className={styles.show}
              onClick={() => setIsVisible((prev) => !prev)}
            >
              {isVisible ? 'Hide number' : 'Show number '}
            </span>
          )}
          {hasMaskedValue && <span className={styles.divider}>|</span>}
          {copyable && (
            <span
              className={styles.copy}
              onClick={() => copyTextToClipboard(value ?? '')}
            >
              Copy
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export { Section, SectionItem }
